/* drowsie-reveal.js — the Oura-style heading entrance, shared by every web page (MN 2026-09-24).
   Measured on ouraring.com/why-oura: the heading BLOCK starts blur(5px) + 25px low + transparent and settles sharp
   over ~1.2s on a decelerating curve. We animate block-level headings only (never inline word spans — that is what
   smeared in Safari on 09-11), and every heading ends on `filter:none`, not blur(0), so WebKit repaints it crisp.

   - Headings already on screen at load are left alone (the page reads at rest).
   - Headings inside a sticky, scroll-driven stage are left alone (they have their own choreography).
   - A heading inside an existing `.rv` reveal only gets the blur (the `.rv` already fades and rises it), cleared by
     this script's OWN observer — never by a page's class name (page 20 marks `rv-in`, others `in`; 09-24 bug).
   - prefers-reduced-motion: off. Compare any page with ?reveal=off. Revert everywhere: ENABLED = false.

   THE BODY ENTRANCE (MN 2026-09-25, from the homepage mock: "everything below it just fades in a little bit … apply
   that to all pages"): the paragraphs, lists, cards, figures and tables under the headings rise 24px and fade in once
   as they arrive — the Web System's `.rv` (0.8s, cubic-bezier(.23,1,.32,1)) — on every page, without each page having
   to mark them. Only blocks nobody animates already: never inside a page's .rv / reveal, a sticky or fixed stage, the
   film, the orb, the plan picker, the cart, the header, menu or footer; never a block that carries its own transform
   or opacity; outermost block only; nothing on screen at load or sideways off screen. Ends on the plain element.
   Revert just this part: BODY = false.
   Include: <script src="{{ 'drowsie-reveal.js' | asset_url }}" defer></script>                                   */
(function () {
  'use strict';
  var ENABLED = true, BODY = true;
  if (!ENABLED || window.__dzReveal || /[?&]reveal=off\b/.test(location.search)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.__dzReveal = 1;

  var EASE = 'cubic-bezier(.22,.61,.36,1)', DUR = '1.1s';
  var css = [
    '.dz-hr{opacity:0;transform:translateY(24px);filter:blur(5px)}',
    '.dz-hr.dz-go{opacity:1;transform:none;filter:none;transition:opacity ' + DUR + ' ' + EASE + ',transform ' + DUR + ' ' + EASE + ',filter ' + DUR + ' ' + EASE + '}',
    '.dz-hb{filter:blur(5px)}',
    '.dz-hb.dz-go{filter:none;transition:filter .9s ' + EASE + '}',
    '.dz-fr{opacity:0;transform:translateY(24px)}',
    '.dz-fr.dz-go{opacity:1;transform:none;transition:opacity .8s cubic-bezier(.23,1,.32,1),transform .8s cubic-bezier(.23,1,.32,1)}'
  ].join('\n');

  var BLOCKS = 'p, ul, ol, figure, article, table, details, blockquote, dl, form';
  var SKIP = '[data-no-reveal], .hdr, #menu, .menu, footer, .dzfoot, .rv, [class*="reveal"], .n12, #loop, #filmnight, ' +
             '.section_spanos, #plan, [role="dialog"], [class*="dzc"], .dz-aura, h1, h2, h3';
  var stickyMemo = new Map();
  function stuck(el) {                                      // el or an ancestor is sticky/fixed (memoised per node)
    var chain = [], v = false;
    for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      if (stickyMemo.has(n)) { v = stickyMemo.get(n); break; }
      chain.push(n);
      var p = getComputedStyle(n).position; if (p === 'sticky' || p === 'fixed') { v = true; break; }
    }
    chain.forEach(function (c) { stickyMemo.set(c, v); }); return v;
  }
  function bodyBlocks(vh, vw) {
    var picked = new Set(), out = [];
    Array.prototype.forEach.call(document.querySelectorAll('main, body > section, body > div'), function (root) {
      if (root.closest(SKIP) || root.classList.contains('dz-aura')) return;
      Array.prototype.forEach.call(root.querySelectorAll(BLOCKS), function (el) {
        if (el.closest(SKIP)) return;
        for (var a = el.parentElement; a && a !== root.parentElement; a = a.parentElement) if (picked.has(a)) return;   // outermost only
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        if (r.top < vh && r.bottom > 0) return;                                      // on screen at load
        if (r.right <= 0 || r.left >= vw) return;                                    // sideways off screen (sliders)
        var cs = getComputedStyle(el);
        if (cs.transform !== 'none' || +cs.opacity < 0.99 || cs.visibility === 'hidden') return;   // animated elsewhere
        if (stuck(el)) return;
        picked.add(el); out.push(el);
      });
    });
    return out;
  }

  function inSticky(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var p = getComputedStyle(n).position; if (p === 'sticky' || p === 'fixed') return true;
    }
    return false;
  }

  function init() {
    var st = document.createElement('style'); st.id = 'dzRevealCss'; st.textContent = css; document.head.appendChild(st);
    var vh = innerHeight, vw = innerWidth, own = [];
    Array.prototype.forEach.call(document.querySelectorAll('main h1, main h2, body > section h1, body > section h2, body > div h2'), function (h) {
      if (h.closest('[data-no-reveal], .hdr, #menu, .menu, footer, .dzfoot') || inSticky(h)) return;   // the site header, not a section's own <header>
      var r = h.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) return;          // on screen at load: leave it
      h.classList.add(h.closest('.rv') ? 'dz-hb' : 'dz-hr'); own.push(h);                 // in a .rv: blur only

    });
    var blocks = BODY ? bodyBlocks(vh, vw) : [];                                  // all reads first, then the writes
    blocks.forEach(function (b) { b.classList.add('dz-fr'); });
    own = own.concat(blocks);
    if (!own.length) return;
    if (!('IntersectionObserver' in window)) { own.forEach(function (h) { h.classList.remove('dz-hr', 'dz-hb', 'dz-fr'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var h = e.target; io.unobserve(h); h.classList.add('dz-go');
        setTimeout(function () { h.classList.remove('dz-hr', 'dz-hb', 'dz-fr', 'dz-go'); }, 1250);   // end on the plain element: crisp in WebKit
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    own.forEach(function (h) { io.observe(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
